<template>
    <modal id="poll-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('poll')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.POLL'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="select"
                        :label="$t('polls.active_status')"
                        list-value-field="translated_name"
                        v-model="formData.status_id"
                        :chooseLabel="$t('status')"
                        :error-message="$errorMessage(errors, 'status_id')"
                        :required="true"
                        :fetch-url="SELECTABLE_POLL_STATUS"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                        <app-form-group
                            :label="$t('description')"
                            type="textarea"
                            v-model="formData.description"
                            :placeholder="$placeholder('description')"
                            :required="true"
                            :error-message="$errorMessage(errors, 'description')"
                        />
                </div>
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="multi-select"
                        :label="$t('departments')"
                        list-value-field="name"
                        v-model="formData.departments"
                        :chooseLabel="$t('departments')"
                        :error-message="$errorMessage(errors, 'departments')"
                        :fetch-url="SELECTABLE_DEPARTMENT"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";
import {SELECTABLE_POLL_STATUS,SELECTABLE_DEPARTMENT} from "../../../../Config/ApiUrl";


export default {
    name: "PollCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                title: '',
                description: '',
                active_status: '',
                departments: []
            },
            SELECTABLE_POLL_STATUS,
            SELECTABLE_DEPARTMENT
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData.active_status = formData.active_status ? 1 : 0;
            formData = formDataAssigner(new FormData, formData);
            this.formData.departments.forEach((id, index) => {
                formData.append(`departments[${index}]`, id);
            });
            let url = this.apiUrl.POLL;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#poll-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'poll-table');
                window.location.reload();
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#poll-modal').modal('hide');
            this.toastAndReload(data.message, 'poll-table')
            this.$emit('input', false);
            window.location.reload();
        },
        afterSuccessFromGetEditData({data}) {
            this.preloader = false;
            //Before customization this was "  this.formData = data;"
            this.formData = {...this.formData, ...data};
            this.formData.departments = this.collection(data.departments).pluck();
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
